<template>
    <el-dialog class="crossExamination" :title="diatorTitle" :visible.sync="dialogVisible" :before-close="handleClose" width="800px">
        <div class="inneExaminationr">
            <!-- <div class="topExamination">
                <div class="nocrossExamination" v-if="editSelect">
                    真实性：
                    <el-select v-model="speciality.realnessType" placeholder="请选择" @change="handleSpeciality">
                        <el-option
                        v-for="item in optionsReality"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    合法性：
                    <el-select v-model="speciality.legalityType" placeholder="请选择" @change="handleSpeciality">
                        <el-option
                        v-for="item in optionsLegal"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    关联性：
                    <el-select v-model="speciality.relevanceType" placeholder="请选择" @change="handleSpeciality">
                        <el-option
                        v-for="item in optionsRelevance"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="yescrossExamination" v-if="!editSelect">
                    <div class="col">真实性：<span>{{speciality.realnessName}}</span></div>
                    <div class="col">合法性：<span>{{speciality.legalityName}}</span></div>
                    <div class="col">关联性：<span>{{speciality.relevanceName}}</span></div>
                </div>
            </div> -->
            <div class="inne-tip">您好，请对本证据的真实性，合法性和关联性进行质证。如确认则无需发表质证意见，如不确认某一性则需说明您不予确认的质证意见。</div>
            <div class="contentExamination">
                <div>
                    <div class="privatchat_main-title">质证记录：</div>
                    <div class="privatchat_main1">
                        <div class="chat-message_list" ref="messageListBox1" id="examinationBox">
                            <ul>
                                <li v-for="msg in msgs" :key="msg.index" :class="{'meeting-chatroom-self': msg.id==comdata.userID}">
                                    <span>{{msg.who}} {{msg.time}}</span>
                                    <div class="infobackground">
                                        <div class="">质证内容：{{msg.content}}</div>
                                    </div>
                                </li>
                            </ul>
                            <div v-if="msgs.length === 0" class="no_list"><img src="../assets/img/no_list.png" alt=""></div>
                        </div>
                        <div class="chat-message_speaking">
                            <textarea v-model="inputMessage" class="input-textarea" placeholder="请输入理由"></textarea>
                        </div>
                    </div>
                </div>
                <div class="chat-message_btnSend">
                    <el-button @click="onSendMessageClick()">提交</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import {addEvidence} from '@/api/meeting.js'
import config from '@/config/config'
import {getStore} from '@/utils/utils.js'
export default {
    components: {
    },
    props: {
        comdata: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            diatorTitle: '质证',
            dialogVisible: false,
            editSelect: true,
            showRecord: false,
            optionsReality: [{
                value: '0',
                label: '真实'
            }, {
                value: '1',
                label: '不真实'
            }],
            optionsLegal: [{
                value: '0',
                label: '合法'
            }, {
                value: '1',
                label: '不合法'
            }],
            optionsRelevance: [{
                value: '0',
                label: '关联'
            }, {
                value: '1',
                label: '不关联'
            }],
            speciality: {
                realnessType: '0',
                realnessName: '真实',
                legalityName: '合法',
                legalityType: '0',
                relevanceName: '关联',
                relevanceType: '0',
            },
            inputMessage: '',   //发送消息
            userToken: '',  //token
            msgs: [],    //消息列表
            ws: '',
            socketStatus: false,
            messagePageIndex: 1,
            messageTotalPages: '',
            onceLoadMessage: true,
            messageListLoad: true,
            messageListBody:'',
            memberstype: {
                "MEDIATOR":"工作人员",
                "APPLICANT":'申请人',
                'APPLICANT_AGENT': '申请人代理人',
                "LITIGANT":'参会人',
                "RESPONDENT":'被申请人',
                'OTHER': '其他人',
                "RESPONDENT_AGENT":'被申请人代理人',
                "PETITION_AGENT":'信访代理人',
                'MEDIATOR_HELP_TEMPORARY':'协助调解员',
                'MEDIATOR_HELP':'协助调解员',
            },
            roomId: [],
            createRoomData: {},
            addEvidenceData: {},
            fileListitem: [],   //当前质证文件
            loginMemberType: '', //当前登陆者角色
            isMedia: true,
        }
    },
    created() {
    },
    mounted() {
        
       let loginInfo = JSON.parse(getStore('loginInfo'))
       this.loginMemberType = loginInfo.memberType ? loginInfo.memberType : 'MEDIATOR'
    },
    methods: {
        handleGetSelectvalue(createRoomData, addEvidenceData, item) {
            this.onceLoadMessage = true
            this.createRoomData = createRoomData
            this.addEvidenceData = addEvidenceData
            this.fileListitem = item
            // this.speciality.realnessType = this.createRoomData.realnessType ? this.createRoomData.realnessType : '0'
            // this.speciality.legalityType = this.createRoomData.legalityType ? this.createRoomData.legalityType : '0'
            // this.speciality.relevanceType = this.createRoomData.relevanceType ? this.createRoomData.relevanceType : '0'
            // this.speciality.realnessName = this.createRoomData.realnessName ? this.createRoomData.realnessName : '真实'
            // this.speciality.legalityName = this.createRoomData.legalityName ? this.createRoomData.legalityName : '合法'
            // this.speciality.relevanceName = this.createRoomData.relevanceName ? this.createRoomData.relevanceName : '关联'
            // if(this.speciality.realnessType == '0' && this.speciality.legalityType == '0' && this.speciality.relevanceType == '0') {
            //     this.showRecord = false
            // } else {
            //     this.showRecord = true
            // }
           //质证三要素：1、自己打开自己的证据 ，三义性不能出现下拉框 2、自己打开自己的证据、只能看， 如有被质证过， 展示质证聊天框及理由框，提交按钮 3、仲裁员打开证据， 只能看
            // if(this.loginMemberType === 'MEDIATOR') {
            //     if(this.createRoomData.realnessName == null) {
            //         this.speciality.realnessName = ''
            //         this.speciality.legalityName = ''
            //         this.speciality.relevanceName = ''
            //     }
            //     this.editSelect = false
            //     this.isMedia = false
            // } else {
            //     if(this.fileListitem.categorySmall === this.loginMemberType) {
            //         this.editSelect = false
            //         if(this.createRoomData.realnessName == null) {
            //             this.speciality.realnessName = ''
            //             this.speciality.legalityName = ''
            //             this.speciality.relevanceName = ''
            //         }
            //         if(this.speciality.realnessType == '0' && this.speciality.legalityType == '0' && this.speciality.relevanceType == '0') {
            //             this.isMedia = false
            //         } else {
            //             this.isMedia = true
            //         }
            //     } else {
            //         if(this.createRoomData.realnessName == null) {
            //             this.speciality.realnessName = ''
            //             this.speciality.legalityName = ''
            //             this.speciality.relevanceName = ''
            //             this.editSelect = true
            //             this.isMedia = true
            //         } else {
            //             if(this.speciality.realnessType == '0' && this.speciality.legalityType == '0' && this.speciality.relevanceType == '0') {
            //                 this.isMedia = false
            //             } else {
            //                 this.isMedia = true
            //             }
            //             this.editSelect = false
            //         }
            //     }
            // }
        },
        enterRoom(roomId) { // websocket链接
            let self = this,
                hostName = config.hostName
                this.userToken = self.$route.query.token || getStore('flk');
            let ws = this.ws = new WebSocket('wss://' + hostName + '/scavengerIm/joinRoom/' + roomId + '?JWTToken=' + this.userToken + '&appName=' + 'gzzc' + '&watcher=' + 'false')
            ws.onopen = function(evt) {
                self.listMessage(self.messagePageIndex);
            };
            ws.onmessage = function(evt) {
                let res = JSON.parse(evt.data)

                if (res.event == "LIST_MESSAGE") {
                    self.loadMsgList(res.data)
                }
                if (res.event == "BROADCAST_MESSAGE") {
                    if (Boolean(res.data.receiver)) {
                        self.uploadMsgList(res.data);
                    } else {
                        self.uploadMsgList(res.data)
                    }
                }
                if (res.event == "HAND") {
                    self.receiveHand(res.data)
                }
                // if (res.event == "ERROR") {
                //     if (res.data['code'] == 1003) {
                //         self.$alert(res.data['message'], '温馨提示', {
                //             confirmButtonText: '确定',
                //             confirmButtonClass: 'meeting_button_primary_small',
                //             showClose: false,
                //             customClass: 'meetbox',
                //             callback: action => {
                //                 // history.back()
                //             }
                //         })
                //     }
                //     if (res.data['code'] == 9999) {
                //         self.$alert(res.data['message'], '温馨提示', {
                //             confirmButtonText: '确定',
                //             confirmButtonClass: 'meeting_button_primary_small',
                //             showClose: false,
                //             customClass: 'meetbox',
                //             callback: action => {
                //                 // history.back()
                //             }
                //         })
                //     } else if (res.data['code'] == 1002) {
                //         self.$alert('请重新登录', '温馨提示', {
                //             confirmButtonText: '确定',
                //             confirmButtonClass: 'meeting_button_primary_small',
                //             showClose: false,
                //             customClass: 'meetbox',
                //             callback: action => {
                //                 self.$router.push({
                //                     path: '/login',
                //                 })
                //             }
                //         })
                //     } else {
                //         self.$alert(res.data['message'], '温馨提示', {
                //             confirmButtonText: '确定',
                //             confirmButtonClass: 'meeting_button_primary_small',
                //             showClose: false,
                //             customClass: 'meetbox',
                //             callback: action => {}
                //         })
                //     }
                // }
                // self.messageListBody = self.$refs.messageListBox1;
                // console.log(self.$refs.messageListBox1.scrollHeight);
            };
            ws.onclose = function(evt) {
            }
        },
        onSendMessageClick() {
            //提交质证
            this.websocketSend()
            // if(this.editSelect) {
            //     addEvidence({
            //         attachmentId: this.addEvidenceData.attachmentId,
            //         caseId: this.addEvidenceData.caseId,
            //         legalityName: this.handleGetName(this.optionsLegal, this.speciality.legalityType),
            //         legalityType: this.speciality.legalityType,
            //         meetingId: this.addEvidenceData.meetingId,
            //         realnessName: this.handleGetName(this.optionsReality, this.speciality.realnessType),
            //         realnessType: this.speciality.realnessType,
            //         relevanceName: this.handleGetName(this.optionsRelevance, this.speciality.relevanceType),
            //         relevanceType: this.speciality.relevanceType
            //     }).then((res) => {
            //         if(res.data.code === 1000) {
            //             this.speciality.realnessName = this.handleGetName(this.optionsReality, this.speciality.realnessType)
            //             this.speciality.legalityName = this.handleGetName(this.optionsLegal, this.speciality.legalityType)
            //             this.speciality.relevanceName = this.handleGetName(this.optionsRelevance, this.speciality.relevanceType)
            //             this.editSelect = false
            //             if(this.speciality.legalityType == '0' && this.speciality.realnessType == '0' && this.speciality.relevanceType == '0') {
            //                 this.isMedia = false
            //             } 
            //         } else {
            //             this.$message.error(res.data.message)
            //         }
            //     })
            // }
        },
        websocketSend() {
            //质证发送websocket
            var self = this;
            var msg = this.inputMessage;
            self.inputMessage = "";
            var data = {
                content: msg,
                messageResource:'HANDLER_INPUT'
            };
            var msgdata = {};
            msgdata.event = "SEND_TEXT";
            msgdata.data = data;
            self.ws.send(JSON.stringify(msgdata))
        },
        uploadMsgList(message) {
            //聊天信息
            this.messagePageIndex = 1
            this.msgs.push({
                who:"【"+this.memberstype[message.sender.memberType]+"】"+(message.sender.memberType === 'MEDIATOR' ? '仲裁员': message.sender.memberName),
                id:message.sender.memberId,
                content:message.messageContent,
                time:this.timestoday(message.createTime),
                type:message.messageResource
            })
            let context=document.getElementById('examinationBox')
            let t =setTimeout(function(){
                context.scrollTop=context.scrollHeight
            },500)
        },
        listMessage(pageindex) { // 拉取消息记录
            let self = this, data, msgdata = {};
            data = {
                pageIndex: 1,  //暂时改成1
                pageSize: 500
            };
            msgdata.event = "LIST_MESSAGE";
            msgdata.data = data;
            self.ws.send(JSON.stringify(msgdata))
        },
        pullMessage() {
            let self = this;
            this.messagePageIndex = 1
            if(self.$refs.messageListBox.scrollTop == 0&&self.messagePageIndex<=self.messageTotalPages&&self.messageListLoad){
                self.messageListLoad = false;
                self.listMessage(self.messagePageIndex);
            }
        },
        loadMsgList(data) {
            this.msgs = []
            this.messagePageIndex = 1
            if(!Boolean(data.list.length)) return;
            let self = this,  messagelist = [], context, t, messageListBody;
            self.messageListBody = messageListBody = document.querySelector('#examinationBox');
            self.messageListLoad = true;
            self.messagePageIndex = Number(self.messagePageIndex) + 1;
            self.messageTotalPages = data.totalPages;
            data.list.forEach((item,index,array) => {
                messagelist.unshift({who:"【"+self.memberstype[item.sender.memberType]+"："+item.sender.memberName+"】",id:item.sender.memberId,content:item.messageContent,time:this.timestoday(item.createTime),type:item.messageResource})
            });
            self.msgs = messagelist.concat(self.msgs);
            if(self.onceLoadMessage) {
                t = setTimeout(function(){self.messageListBody.scrollTop=self.messageListBody.scrollHeight},200)
                self.messageListBody.addEventListener('scroll', self.pullMessage, false);
            }
            self.onceLoadMessage = false;
            if(self.messagePageIndex>data.totalPages){
                self.messageListBody.removeEventListener('scroll', self.pullMessage, false);
            }
        },
        timestoday(t) {
            var times = new Date(t);
            var ty = times.getFullYear(), tm = times.getMonth()+1, td = times.getDate(), th = times.getHours(), tmt = times.getMinutes(), ts = times.getSeconds();
            var ntostring = function(d){
                if(d.toString().length ==1){
                    return "0"+d;
                }
                return d;
            }
            return ntostring(th)+":"+ntostring(tmt)+":"+ntostring(ts);
        },
        handleGetName(options, Type) {
            //筛选质证参数
            var ret1 = options.find(item => {
                if(item.value === Type)
                return item.label
            })
            return ret1.label
        },
        handleSpeciality(value) {
            if(this.speciality.realnessType === '0' && this.speciality.legalityType === '0' && this.speciality.relevanceType === '0') {
                this.showRecord = false
            } else {
                this.showRecord = true
            }
        },
        handleClose(done) {
            this.$emit('comcallback');
            this.ws.close();
            done();
        }
    }
}
</script>

<style lang="scss">
    .crossExamination {
        .el-dialog__header {
            border-bottom: 1px solid #e5e5e5;
            .el-dialog__title {
                margin-left: 10px;
            }
            span:before {
                content: "";
                position: absolute;
                display: block;
                left: 19px;
                top: 22px;
                width: 4px;
                height: 0;
                border-top: 20px solid #1e6dcb;
            }
        }
        .inneExaminationr {
            .topExamination {
                padding-bottom: 30px;
                .nocrossExamination {
                    display: flex;
                    align-items: center;
                    justify-content: space-evenly;
                    .el-select {
                        width: 140px;
                    }
                }
                .yescrossExamination {
                    display: flex;
                    align-items: center;
                    justify-content: space-evenly;
                    .col {
                        color: #999999;
                        span {
                            color: #333333;
                        }
                    }
                }
            }
            .inne-tip {
                color: #000000;
                width: 90%;
                margin: 0 auto 30px;
            }
            .contentExamination {
                .privatchat_main-title {
                    // padding-top: 30px;
                }
                .privatchat_main1 {
                    position: relative;
                    // height: 350px;
                    .currentChatMember {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        height: 25px;
                        line-height: 25px;
                        text-align: center;
                        font-size: 14px;
                        color: #0083c8;
                        background-color: #fff;
                    }
                    .chat-message_list {
                        // position: absolute;
                        // top: 25px;
                        // bottom: 125px;
                        // left: 0;
                        // right: 0;
                        // margin: 0;
                        height: 200px;
                        margin-bottom: 10px;
                        padding: 20px;
                        border-radius: 2px;
	                    border: solid 1px #e6e6e6;
                        box-sizing: border-box;
                        overflow-y: auto;
                        li {
                            padding: 10px 0 15px;
                            span {
                                display: block;
                                padding-bottom: 6px;
                                color: #888888;
                                font-size: 14px;
                            }
                            div.infobackground {
                                position: relative;
                                display: inline-block;
                                padding: 10px 15px;
                                line-height: 22px;
                                color: #494949;
                                font-size: 14px;
                                background-color: #f7f7f7;
                                border: 1px solid #f0f0f0;
                                border-radius: 2px;
                                text-align: left;
                            }
                        }
                        li.meeting-chatroom-self {
                            text-align: right;
                            div.infobackground {
                                color: #333333;
                                background-color: #f7f7f7;
                                border: 1px solid #f7f7f7;
                            }
                        }
                        .no_list {
                            img {
                                display: block;
                                margin: 40px auto 0;
                            }
                        }
                    }
                    .chat-message_speaking {
                        // position: absolute;
                        // left: 0;
                        // right: 0;
                        // bottom: 10px;
                        height: 80px;
                        padding: 10px;
                        background-color: #ffffff;
                        border-radius: 2px;
	                    border: solid 1px #e6e6e6;
                        .input-textarea {
                            font-size: 12px;
                            width: 100%;
                            height: 80px;
                            display: inline-block;
                            padding: 5px 10px;
                            border: none;
                            color: #494949;
                            background-color: #ffffff;
                            resize: none;
                            outline: 0;
                            -webkit-appearance: none;
                            -webkit-box-sizing: border-box;
                            box-sizing: border-box;
                            -webkit-transition: all .3s cubic-bezier(.645,.045,.355,1);
                            -webkit-transition: all .3s cubic-bezier(0.65, 0.05, 0.36, 1);
                            transition: all .3s cubic-bezier(0.65, 0.05, 0.36, 1);
                        }
                        .input-textarea::-webkit-input-placeholder {
                            color: #ccc;
                            font-size: 14px;
                        }
                    }
                }
                .chat-message_btnSend {
                    display: inline-block;
                    vertical-align: top;
                    text-align: center;
                    width: 100%;
                    padding-top: 20px;
                    button {
                        width: 150px;
                        height: 46px;
                        border-radius: 4px;
                        color: #fff;
                        border: none;
                        outline: 0;
                        background-color: #0083c8;
                        box-shadow: 0 5px 8px 0 rgba(0, 117, 206, 0.25);
                        cursor: pointer;
                    }
                }
            }
        }
    }
</style>
